import { jsx as o } from "react/jsx-runtime";
const e = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m3 3 18 18M10.584 10.587a2 2 0 1 0 2.828 2.83M9.363 5.365A9.5 9.5 0 0 1 12 5q6 0 10 7-1.167 2.042-2.503 3.488m-2.14 1.861Q14.912 18.999 12 19q-6 0-10-7 2.053-3.592 4.632-5.341"
      }
    )
  }
);
export {
  e as default
};
